// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function tryGetErrorCode(error: any): string | undefined {
    return error.errorMessage?.split(': ')?.[0];
}
